const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');

function parseResult(res) {
  return JSON.stringify(res);
}

function parseCountryResult(res) {
  if ((!res) || res.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(res);
  }
}

function serviceFactory({ api }) {
  
  const validateBeneficiary = (details, metaData) =>
    api.validateBeneficiary(details, metaData)
      .then(parseResult)
      .catch(() => null);


    const getBeneficiaryList = (inputParam, metaData) =>
      api.getBeneficiaryList(inputParam, metaData)
      .then(parseResult)
      .catch(() => null);

    const getBeneficiaryListAll = (inputParam, metaData) =>
      api.getBeneficiaryListAll(inputParam, metaData)
      .then(parseResult)
      .catch(() => null);

    
    const addBeneficiaryDetails = memoizer()((inputParam, metaData) =>
        
      api.addBeneficiaryDetails(inputParam, metaData).then((response) => {
        if (!response) return null;
        return JSON.stringify(response);
      }).catch((error) => {
        return null;
      })
    );

    const paymentsBenValidate = ({inputParam, metaData}) => 
      api.paymentsBenValidate(inputParam,metaData)
        .then(parseCountryResult)
        .catch( (error) => {
          return null;
        });

    const beneficiariesNamesPatch = ({ inputParam, metaData }) =>
      api.beneficiariesNamesPatch(inputParam, metaData)
        .then(parseCountryResult)
        .catch( (error) => {
          return null;
        });

  return {
    validateBeneficiary,
    getBeneficiaryList,
    getBeneficiaryListAll,
    addBeneficiaryDetails,
    paymentsBenValidate,
    beneficiariesNamesPatch
  };

}
module.exports = serviceFactory;